<template>
  <div class="tab-pane" id="dtab2" role="tabpanel">
    <div class="layoptions mb-3">
      <h3>Layout Optionen</h3>
      <div class="switch">
        <label class="w-100"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100 pl-2"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100 pl-2"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>
    </div>

    <div class="mb-3">
      <h3>Seitenhintergrund importieren</h3>
      <p class="font12 mb-1">PDF Datei als Seitenhintergrund importieren. </p>
      <button type="button" class="btn btn-light"> Auswählen </button>
    </div>

    <div class="tabolist mb-3">
      <ol>
        <li>Kein Seitenhintergrund</li>
        <li>Hintergrund 2
          <a type="button" class="float-right" data-toggle="modal" data-target=".vorlage">
            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </a>
        </li>
        <li>Hintergrund 3</li>
      </ol>
    </div>

    <div class="fotoayout mb-3">
      <h3>Foto Layout</h3>
      <div class="flayout mb-2">
        <img src="@/assets/images/layout1.png" alt="icon-layout">
        <img src="@/assets/images/layout2.png" alt="icon-layout">
        <img src="@/assets/images/layout3.png" alt="icon-layout">

      </div>

      <div class="switch">
        <label class="w-100"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100"> Nur aktive Pläne
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/ConstructionLayoutsTab.vue